/* The Proposal Box Collection - collection page behaviour (loaded by bbox-collection-hero.liquid)
   1. The dots under the tier cards follow the phone scroller.
   2. The sticky "Choose her box" bar shows until the cards are on screen.
   3. Arriving with #compare / #boxes / #how / #faq (e.g. "Compare all five" on a box page): the hero's inline
      script held the browser's instant jump; scroll there smoothly once fonts + images have loaded, then put
      the hash back in the address bar. A second pass catches any late layout shift. */
(function () {
  var SCROLL = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
  function arrive() {
    var h = window.__bbxHash; if (!h || arrive.done) return;
    var t = document.querySelector(h); if (!t) return;
    arrive.done = true;
    var go = function () { t.scrollIntoView({ behavior: SCROLL, block: 'start' }); };
    var start = function () {
      var fonts = (document.fonts && document.fonts.ready) || Promise.resolve();
      fonts.then(function () {
        requestAnimationFrame(go);
        setTimeout(go, 1200);
        try { history.replaceState(null, '', location.pathname + location.search + h); } catch (e) { }
      });
    };
    if (document.readyState === 'complete') start(); else window.addEventListener('load', start);
  }
  /* 4. "What goes inside" tiles: larger preview in place, instead of leaving for the item's product page */
  function zoom() {
    if (document.body.dataset.bbxZoomReady || !document.querySelector('[data-bbx-zoom]')) return;
    document.body.dataset.bbxZoomReady = '1';
    var ov = document.createElement('div'); ov.className = 'bbx-zoom'; ov.hidden = true; ov.setAttribute('role', 'dialog'); ov.setAttribute('aria-modal', 'true');
    ov.innerHTML = '<figure><button type="button" class="bbx-zoom__close" aria-label="Close">&times;</button><img alt=""><figcaption></figcaption></figure>';
    document.body.appendChild(ov);
    var img = ov.querySelector('img'), cap = ov.querySelector('figcaption'), x = ov.querySelector('.bbx-zoom__close'), last = null;
    function close() { ov.hidden = true; document.documentElement.classList.remove('bbx-zoom-open'); if (last) { try { last.focus({ preventScroll: true }); } catch (e) { } } }
    document.addEventListener('click', function (e) {
      var b = e.target.closest('[data-bbx-zoom]');
      if (b) { e.preventDefault(); last = b; img.src = b.getAttribute('data-bbx-zoom'); img.alt = b.getAttribute('data-bbx-cap') || ''; cap.textContent = img.alt; ov.hidden = false; document.documentElement.classList.add('bbx-zoom-open'); x.focus(); return; }
      if (!ov.hidden && (e.target === ov || e.target.closest('.bbx-zoom__close'))) close();
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !ov.hidden) close(); });
  }
  function init() {
    arrive(); zoom();
    var tiers = document.querySelector('[data-bbx-tiers]');
    var dots = document.querySelector('[data-bbx-dots]');
    if (tiers && dots && !tiers.dataset.bbx) {
      tiers.dataset.bbx = '1';
      var items = dots.querySelectorAll('i');
      var n = tiers.children.length || 1;
      var upd = function () {
        var i = Math.round(tiers.scrollLeft / (tiers.scrollWidth / n));
        for (var k = 0; k < items.length; k++) items[k].classList.toggle('is-on', k === i);
      };
      tiers.addEventListener('scroll', upd, { passive: true });
      upd(); // the markup pre-lights the featured card's dot; on load the scroller is at the first card
    }
    var bar = document.querySelector('[data-bbx-float]');
    if (bar && !bar.dataset.bbx && 'IntersectionObserver' in window) {
      bar.dataset.bbx = '1';
      var target = document.querySelector(bar.getAttribute('data-bbx-watch') || '#boxes');
      if (target) {
        new IntersectionObserver(function (entries) {
          bar.classList.toggle('is-on', !entries[0].isIntersecting && entries[0].boundingClientRect.top > 0);
        }, { threshold: 0 }).observe(target);
      }
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
